import Vue from "vue";
import { FORM_TYPE } from "../constants/custom-define-type";

Vue.mixin({
  methods: {
    getValueOfObjectKey(dataObject, key) {
      const tokens = key.split(/[\.\[\]]+/);
      let objValue = dataObject;
      for (const token of tokens) {
        if (token.length === 0) {
          continue;
        }
        objValue = objValue[token];
      }
      return objValue;
    },
    isMissingField(dataObject, fieldName, type) {
      const objValue = this.getValueOfObjectKey(dataObject, fieldName);
      if (objValue == null) {
        return true;
      }
      if (type === FORM_TYPE.DAY_HOURS_SELECTOR) {
        /*
        objValue includes 5 element (corresponding with Monday -> Friday)
        Each row of day hours selector includes a checkbox, and two time picker
        If the checkbox is not check, the corresponding value is "" (empty string)
        If the checkbox is checked, but none of the time picker is filled, the value is ","
        If the checkbox is checked, but the 'from' time picker is not filled, the value is ",to"
        If the checkbox is checked, but the 'to' time picker is not filled, the value is "from,"
        */

        // Check if all checkbox is unchecked.
        if (!objValue.some(val => val != null && val !== "")) {
          return true;
        }
        if (objValue != null && Array.isArray(objValue)) {
          for (const val of objValue) {
            // If value contains ',' => checkbox is checked.
            if (val.includes(",")) {
              const tokens = val.split(",");
              for (const token of tokens) {
                // Check if 'from' or 'to' is missing
                if (token.trim().length === 0) {
                  return true;
                }
              }
            }
          }
        }
      }

      if (type === FORM_TYPE.SALARY_RANGE) {
        // objValue of salary range includes 3 element (min salary, max salary, salary option)
        // If any of those value is empty => the field is not filled
        if (objValue == null) {
          return true;
        }
        if (objValue != null && Array.isArray(objValue)) {
          for (const val of objValue) {
            if (val.trim().length === 0) {
              return true;
            }
          }
        }
      }
      // Empty string
      if (typeof objValue === "string") {
        if (objValue.length === 0) {
          return true;
        }
      }
      if (typeof objValue === "object") {
        if (Array.isArray(objValue)) {
          // Empty array
          if (objValue.length === 0) {
            return true;
          }
        } else if (!(objValue instanceof Date)) {
          // Empty object
          if (Object.keys(objValue).length === 0) {
            return true;
          }
        }
      }
      return false;
    },
    hasInvalidField(dataObject, listElement) {
      for (const element of listElement) {
        // Ignore the field which is not show
        if (!this.isItemShow(dataObject, element)) {
          continue;
        }
        if (element.validation) {
          const objValue = this.getValueOfObjectKey(dataObject, element.model);
          if (objValue != null && objValue !== "") {
            for (const validateItem of element.validation) {
              if (!validateItem.regex.test(objValue)) {
                return true;
              }
            }
          }
        }
        if (element.isRequired === false) {
          continue;
        }
        if (!element.model) {
          continue;
        }
        if (this.isMissingField(dataObject, element.model, element.type)) {
          return true;
        }
      }
      return false;
    },
    hasMissingRequireFieldByKeys(
      dataObject,
      listRequiredField,
      listRequiredCheckbox = null
    ) {
      for (const requiredField of listRequiredField) {
        const objValue = this.getValueOfObjectKey(dataObject, requiredField);
        if (objValue == null) {
          return true;
        }
        // Empty string
        if (typeof objValue === "string") {
          if (objValue.length === 0) {
            return true;
          }
        }
        if (typeof objValue === "object") {
          if (Array.isArray(objValue)) {
            // Empty array
            if (objValue.length === 0) {
              return true;
            }
          } else if (!(objValue instanceof Date)) {
            // Empty object
            if (Object.keys(objValue).length === 0) {
              return true;
            }
          }
        }
      }

      if (listRequiredCheckbox != null) {
        for (const checkboxField of listRequiredCheckbox) {
          const objValue = this.getValueOfObjectKey(dataObject, checkboxField);
          if (objValue != true) {
            return true;
          }
        }
      }
      return false;
    },
    getFirstNameAndLastName(name) {
      const trimedName = name.trim();
      if (trimedName.includes(" ")) {
        const spaceIndex = trimedName.indexOf(" ");
        const firstName = trimedName.substr(0, spaceIndex).trim();
        const lastName = trimedName.substr(spaceIndex + 1);
        return { firstName: firstName, lastName: lastName };
      } else {
        return { firstName: trimedName, lastName: "" };
      }
    },
    extractSelectedFields(inputObject, listFields) {
      const listSelectedKey = listFields.map(field => field.model);
      const result = {};
      for (const key of Object.keys(inputObject)) {
        if (listSelectedKey.includes(key)) {
          result[key] = inputObject[key];
        }
      }
      return result;
    },
    isUnchangedObject(object1, object2, listFields) {
      const listSelectedKey = listFields.map(field => field.model);
      for (const key of listSelectedKey) {
        if (object1[key] !== object2[key]) {
          return false;
        }
      }
      return true;
    },
    // Check if item is showed (Item may not showed if showIf is set)
    isItemShow(modelData, el) {
      // showIf is not set => item is showed
      if (el.showIf == null) {
        return true;
      }
      /* showIfValue is not set => 
      item is only show if the corresponding value of model for showIf is true (Yes/No radio group)
      */
      if (el.showIfValue == null) {
        return modelData[el.showIf] === true;
      } else {
        /* show if value of dropdown option is in list of option (showIfValue is an array)) */
        if (Array.isArray(el.showIfValue)) {
          return el.showIfValue.includes(modelData[el.showIf]);
        } else {
          /* show if value of dropdown option is one option (showIfValue is string) */
          return modelData[el.showIf] === el.showIfValue;
        }
      }
    },
    // Validate mising file, or file exceed maximum
    isFileValid(file, isRequired, maxSize = 10.24) {
      if (file == null) {
        return !isRequired;
      }
      if (file.size > maxSize * 1024 * 1024) {
        return false;
      }
      return true;
    },
    // Validate if a list of file contains any invalid file (missing or file size exceed maximum)
    hasInvalidFile(uploadFiles, listFileInfo) {
      for (const item of listFileInfo) {
        if (!this.isFileValid(uploadFiles[item.model], item.isRequired)) {
          return true;
        }
      }
      return false;
    },
    /* This method receive a list of field,
    then filter out all field which is not corresponding with an option.
    In list field input, it contains information of showIf and showIfValue.
    The output will be filtered based on that.
    And it return list of the filtered fields.
    */
    getListFieldModelForOption(listField, option) {
      return listField.filter(field => {
        // Filter out the fields which does not have model property
        if (!field.model) {
          return false;
        }
        // If showIf is not set, that's mean the field is exist on all options
        if (!field.showIf) {
          return true;
        }
        // showIf is set and showIfValue is not set
        if (field.showIfValue == null) {
          // The existence of item depends on the existence of the refer field (field is specified by showIf)
          const referField = listField.find(
            field2 => field2.model === field.showIf
          );
          // Check if the refer field is exist,
          if (!referField.showIf) {
            return true;
          }
          if (!referField.showIfValue) {
            // showIfValue is not set => the yes/no radio
            return true;
          } else {
            // Check if the refer field is exist by value of showIfValue
            return this.isFieldExistForOption(referField, option);
          }
        } else {
          return this.isFieldExistForOption(field, option);
        }
      });
    },
    /*
    Check if field is exist based on it's showIfValue.
    The input field of this function has both showIf and showIfValue property
    */
    isFieldExistForOption(field, option) {
      if (Array.isArray(field.showIfValue)) {
        return field.showIfValue.includes(option);
      } else {
        return field.showIfValue === option;
      }
    }
  }
});



// WEBPACK FOOTER //
// ./src/mixins/data-handling.js